export const THEME_TYPE  = 2;
export const SP_APP_TYPE = 5;
